import { useAlert } from "@debitroom-software/vuetify-alert";
import { isAxiosError } from "axios";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";
import i18n from "@/shared/plugins/i18n";

const { showAlert, closeAlert } = useAlert();
const t = i18n.global.t.bind(i18n.global);

export function onResponseSuccess(response: any) {
  const authorisationStore = useAuthorisationStore();
  authorisationStore.redirectToAfterLoginUrl = undefined;
  return response;
}

export async function onResponseFailed(error: any) {
  if (isAxiosError(error) && error.code === "ERR_NETWORK") {
    handleNetworkError();
    return Promise.reject({
      isHandled: true,
      message: "Network error handled gracefully"
    });
  }
  if (isAxiosError(error) && error.response && error.response.status === 429) {
    handle429Error(error);
    return Promise.reject({
      isHandled: true,
      message: "429 error handled gracefully"
    });
  }
  if (isAxiosError(error) && error.response && error.response.status === 401) {
    const authClient = await getAuthClient();
    await authClient.login({ authUrlParams: { prompt: "login" } });
    return Promise.reject({
      isHandled: true,
      message: "401 error handled gracefully"
    });
  }

  return Promise.reject(error);
}

let timeout: ReturnType<typeof setTimeout> | null;
let interval: ReturnType<typeof setInterval> | null;
function handle429Error(error: any) {
  let seconds: number = error.response.headers["retry-after"] || 0;
  set429Alert(seconds);

  if (timeout) {
    clearTimeout(timeout);
  }
  if (interval) {
    clearInterval(interval);
  }

  timeout = setTimeout(() => {
    closeAlert();
    if (interval) {
      clearInterval(interval);
    }
  }, seconds * 1000);

  interval = setInterval(() => {
    seconds--;
    set429Alert(seconds);
  }, 1000);
}

function handleNetworkError() {
  showAlert({
    title: t("global.errors.titles.network"),
    message: t("global.errors.messages.network"),
    type: "error",
    hasCloseButton: true
  });
}

function set429Alert(seconds: number) {
  showAlert({
    title: t("global.errors.titles.429"),
    message: t("global.errors.messages.429", { seconds }),
    hasCloseButton: false
  });
}
